// Tree menu vybrané skupiny — klik na libovolný uzel (list i uzel s dětmi) vybírá skupinu (viz doc/plans/station-group-layout.md sekce I.1 bod 7–8)
import { useState } from 'react'

function GroupTreeNode({ node, level, path, selectedPath, onSelect }) {
  const [expanded, setExpanded] = useState(level === 0)
  const hasChildren = node.children && node.children.length > 0
  const currentPath = [...path, { levelIdx: level, bucketLabel: node.label }]
  const isSelected = selectedPath.length === currentPath.length &&
    selectedPath.every((step, i) => step.bucketLabel === currentPath[i].bucketLabel)

  return (
    <div>
      <div className="flex items-center gap-1 py-0.5 px-1 hover:bg-gray-50 rounded text-xs">
        {hasChildren ? (
          <button onClick={() => setExpanded(v => !v)} className="w-4 h-4 flex items-center justify-center text-gray-400 hover:text-gray-600 shrink-0">
            {expanded ? '▼' : '▶'}
          </button>
        ) : (
          <div className="w-4 shrink-0" />
        )}
        <button
          onClick={() => onSelect(currentPath)}
          className={`flex-1 text-left py-0.5 px-1 rounded ${isSelected ? 'bg-blue-100 text-blue-700 font-medium' : 'hover:font-medium'}`}
        >
          {node.label} <span className="text-gray-400">({node.ghIds.size})</span>
        </button>
      </div>

      {expanded && hasChildren && (
        <div className="ml-2 border-l border-gray-100 pl-1">
          {node.children.map((child, idx) => (
            <GroupTreeNode
              key={`${level}-${idx}-${child.label}`}
              node={child}
              level={level + 1}
              path={currentPath}
              selectedPath={selectedPath}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export function GroupTree({ tree, selectedPath, onSelect }) {
  if (!tree || tree.length === 0) {
    return <div className="text-xs text-gray-400 px-2 py-3">Žádné stanice po filtraci — zkuste upravit skupinu nebo filtry.</div>
  }
  return (
    <div className="flex flex-col gap-0.5 text-xs">
      {tree.map((node, idx) => (
        <GroupTreeNode
          key={`0-${idx}-${node.label}`}
          node={node}
          level={0}
          path={[]}
          selectedPath={selectedPath}
          onSelect={onSelect}
        />
      ))}
    </div>
  )
}
